// import axios from 'axios'
import stringify from 'qs-stringify'
import { jsonp } from './fetch-res'
import { getCookie } from '~/plugins/xl-cookie'

const Params = {
  num: 1,
  userid: getCookie('userid'),
  productId: '3001042'
}

export function qrCode({ rmb, ext2 = {} }) {
  ext2.referfrom = getCookie('xwgame_referfrom')
  ext2.actfrom = getCookie('xwgame_actfrom')
  const queries = stringify({
    ...Params,
    rmb,
    productType: 8,
    ext2: stringify(ext2),
    referfrom: getCookie('xwgame_referfrom'),
    wapUrl: 'https://pay-youxi.xunlei.com/paystart'
  })
  return jsonp(
    'https://agent-paycenter-ssl.xunlei.com/payorder/v3/SuperQrcode?' + queries
  ).then((rep) => {
    const res = rep.data
    if (res && res.ret === 200 && res.data.code === 300) {
      return res.data.qrcode
    } else {
      return Promise.reject(res)
    }
  })
}

export function bankPay({ rmb, bankNo, ext2 = {} }) {
  ext2.referfrom = getCookie('xwgame_referfrom')
  ext2.actfrom = getCookie('xwgame_actfrom')
  const queries = stringify({
    ...Params,
    rmb,
    bankNo,
    paytype: 'B',
    currency: 0,
    ext2: stringify(ext2),
    referfrom: getCookie('xwgame_referfrom'),
    peerId: 'pc',
    xDeviceId: getCookie('deviceid')
  })
  return jsonp(
    'https://agent-paycenter-ssl.xunlei.com/payorder/v3/Order?' + queries
  ).then((rep) => {
    const res = rep.data
    if (res && res.ret === 200 && res.data.code === 200) {
      return res.data.url
    } else {
      return Promise.reject(res)
    }
  })
}
